import React from 'react';
import { Link } from 'react-router-dom';
import SignupWizard from '../../components/Auth/SignupWizard';

const Register: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800 text-white">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(59,130,246,0.15),transparent_25%),radial-gradient(circle_at_80%_0,rgba(99,102,241,0.18),transparent_22%),radial-gradient(circle_at(50%_80%),rgba(148,163,184,0.2),transparent_20%)] pointer-events-none" />

      {/* Top Bar with logo */}
      <div className="relative z-10">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-6">
          <div className="flex items-center space-x-3">
            <img src="/icon32.png" alt="NexusSales logo" className="h-10 w-10 rounded-xl shadow-lg shadow-primary-600/40 object-contain" />
            <div>
              <div className="text-2xl font-semibold">NexusSales</div>
              <p className="text-sm text-slate-300">Launch and scale your client communications</p>
            </div>
          </div>
          <div className="flex items-center space-x-3 text-sm">
            <span className="hidden sm:inline text-slate-300">Already have an account?</span>
            <Link
              to="/login"
              className="inline-flex px-4 py-2 rounded-lg border border-white/20 bg-white/5 hover:bg-white/10 font-semibold"
            >
              Back to login
            </Link>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-width-6xl mx-auto px-6 pb-16 pt-4 flex flex-col items-center">
        <div className="mb-6 text-center max-w-2xl">
          <h1 className="text-3xl sm:text-4xl font-bold mb-2">Get started with Nexussales.io</h1>
          <p className="text-slate-200">
            Tell us a bit about you and your business so we can configure your account for SMS, email, and workflow
            automation from day one.
          </p>
        </div>
        <SignupWizard />
      </div>
    </div>
  );
};

export default Register; 
